import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Address } from "components/Address/Address";
import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import Datepicker from "components/DatePicker/DatePicker";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Headerbar } from "components/Headerbar/Headerbar";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Person } from "components/Person/Person";
import { Position } from "components/Position/Position";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useRef, useState } from "react";
import {
  ContactType,
  CustomerDictionaryShowMethod,
  MessageType,
} from "types/enum";
import { GUID_EMPTY, ICON_TYPE } from "utils/constants";
import {
  convertAddress,
  ConvertiSolarDateToGregorianDate,
  GroupingPriceFunction,
  RoundOutputOperation,
  trans,
} from "utils/helpers";
import { CustomerTabform } from "../../Sales/BaseDefinitionAndSetting/Customers/CustomerTabForm";
import { ItemRequestDetailForm } from "./ItemRequestDetailForm";
import {
  // getDataForPrint,
  getDefaultPersonContact,
  getInvoiceConstraint,
  getItemRequestById,
  getItemRequestByReferenceId,
  getItemRequestOrGenerate,
  getPersonCustomer,
  postItemRequest,
  postItemRequestWorkFlow,
  putItemRequest,
  putItemRequestworkflow,
} from "./api";
import { AddressBox } from "./components/AddressBox/AddressBox";
import { CustomerDictionary } from "./components/CustomerDictionary/CustomerDictionary";
import { CustomerPhoneDictionary } from "./components/CustomerPhoneDictionary/CustomerPhoneDictionary";
import { CustomerPhoneList } from "./components/CustomerPhones/CustomerPhoneList";

import { getItemRequestNo } from "./components/ItemRequestNo/api";
import { ItemRequestSourceId } from "./components/ItemRequestSourceId";
import { PriceListDictionary } from "pages/InventoryAndSales/Sales/PriceList/components/PriceListDictionary/PriceListDictionary";

interface ItemRequestFormProps {
  onHide?: (usenavigate?) => void;
  handleCancelForm?: () => void;
  relod: () => void;
  jobId?: any;
  JobNo?: any;
  processId?: any;
  referenceId?: any;
  taskId?: any;
  mode: any;
  step?: any;
  rowObject?: any;
  SourceData?: any;
  sourceDataParam?: any;
  useGenerate?: any;
  sourceId?: any;
  buttonPrintObjCallBack?: (any) => void;
}

export const ItemRequestForm = ({
  mode = "create",
  relod,
  onHide,
  handleCancelForm,
  rowObject,
  step,
  referenceId,
  taskId,
  jobId,
  JobNo,
  processId,
  sourceDataParam,
  SourceData,
  useGenerate = true,
  sourceId,
  buttonPrintObjCallBack,
}: ItemRequestFormProps) => {
  const [resetForm, setResetForm] = useState(false);
  const [haveSource, setHaveSource] = useState(null);
  const [response, setResponse] = useState<any>();
  const [loading, setLoading] = useState<any>(false);
  const [userChanges, setUserChanges] = useState({});
  const [listPosition, setListPosition] = useState<any>({});
  const [customerInfo, setCustomerInfo] = useState<any>(null);
  const [customer, setCustomer] = useState<any>(null);
  const [salesInvoiceDate, setItemRequestDate] = useState<any>();
  const [cottageDate, setCottageDate] = useState<any>();
  const [selectedObj, setSelectedObj] = useState<any>(null);
  const [showForm, setShowForm] = useState(false);
  const [showAddressBox, setShowAddressBox] = useState<
    "createMode" | "selectMode" | null
  >(null);
  const [showCustomerPhoneForm, setShowCustomerPhoneForm] = useState(false);
  const [showCustomerform, setShowCustomerform] = useState<boolean>(false);
  const [priceList, setPriceList] = useState<any>(null);
  const [salesInvoiceDetail, setItemRequestDetail] = useState<any>([]);
  const [dataGridLoading, setDataGridLoading] = useState<any>(true);
  const [lastWarehouse, setLastWarehouse] = useState<any>(null);
  const [invoiceConstraint, setInvoiceConstraint] = useState<any>({});
  const [responseList, setResponseList] = useState<any>(null);

  const [docsClassification, setDocsClassification] = useState<any>(null);
  const [totalRows, setTotalRows] = useState<any>({
    ItemCount: 0,
  });

  const [todayDate, settodayDate] = useState<string | null>(
    new Date().toISOString()
  );
  const [optionalDiscount, setOptionalDiscount] = useState<any>(null);
  const [dataChange, setDataChange] = useState<any>(false);
  const [detailMode, setDetailMode] = useState<"create" | "edit" | "view">(
    mode
  );
  const [increased, setIncreased] = useState<any>(false);
  const [currencyInfo, setCurrencyInfo] = useState<any>();
  const [changeAddress, setChangeAddress] = useState<any>();
  const [typePhoneContact, setTypePhonContact] = useState<any>();
  const [SendSMS, setSendSMS] = useState(false);
  const [nextInvoiceNumber, setNextInvoiceNumber] = useState<any>();
  const [person, setPerson] = useState<any>(null);
  const [noAccess, setNoAccess] = useState<any>(false);
  const [dateLoading, setDateLoading] = useState(true); //for calc fun is runing
  const [selectedPhoneDetail, setSelectedPhoneDetail] = useState<any>({
    phone: "",
    mobilePhone: "",
  });
  const [requiredFields, setRequiredFields] = useState<any>();
  const invoiceRef = useRef<any>(null);
  const invoiceRef1 = useRef<any>(null);
  const lang = localStorage.getItem("DefaultLanguage");

  function setItemRequestDetailHandler(data) {
    setDataGridLoading(false);
    setItemRequestDetail(data);
    setDataGridLoading(true);
  }

  const handleItemRequestDetailFormSubmit = async (event) => {
    event.preventDefault();
    let SubTotalPrice: any = 0;
    let newsalesInvoiceDetail = JSON.parse(
      JSON.stringify(salesInvoiceDetail)
    ).map((e: any) => {
      SubTotalPrice = +e.TotalPrice + SubTotalPrice;
      delete e.Id;
      return e;
    });

    let data = {
      RecipientPersonDescription: person?.Name ?? null,
      RecipientPersonId: person?.Id ?? null,

      ItemRequestNo: event.target?.salesInvoiceNo?.value
        ? event.target?.salesInvoiceNo?.value
        : nextInvoiceNumber,
      ItemRequestDate: salesInvoiceDate,
      SalesManagerPositionId: listPosition?.SalesManagerPosition?.Id,
      SalesManagerPositionDescription: listPosition?.SalesManagerPosition?.Name,
      SalesManagerPositionDescriptionEN:
        event.target.SalesManagerPositionDescriptionEN?.value,
      VisitorPositionId: listPosition?.VisitorPosition?.Id,
      VisitorPositionDescription: listPosition?.VisitorPosition?.Name,
      VisitorPositionDescriptionEN:
        event.target.VisitorPositionDescriptionEN?.value,
      DistributorPositionId: listPosition?.DistributorPosition?.Id,
      DistributorPositionDescription: listPosition?.DistributorPosition?.Name,
      DistributorPositionDescriptionEN:
        event.target.DistributorPositionDescriptionEN?.value,
      CottageDate: cottageDate,
      DeliveryAddress: event.target.DeliveryAddress?.value,
      CottageNo: event.target.CottageNo?.value,

      Description: event.target.Description?.value,
      SourceId: response?.SourceId,
      SourceData: response?.SourceData,
      ItemRequestDetailDTOList: newsalesInvoiceDetail,
    };
    try {
      if (!jobId) {
        if (mode == "create") {
          const res = await postItemRequest(data, SendSMS);
          if (res.MessageType == MessageType.success) {
            onHide && onHide(true);
            relod();
          }
        } else {
          const res = await putItemRequest({
            ...data,
            JobId: response.JobId,
            JobNo: response.JobNo ? response.JobNo : JobNo,
            TAS_UID: taskId,
            Id: response?.Id,
          });
        }
      } else {
        if (response.Id == GUID_EMPTY) {
          const res = await postItemRequestWorkFlow(
            {
              ...data,
              JobId: jobId,
              JobNo: response.JobNo ? response.JobNo : JobNo,
              TAS_UID: taskId,
              Id: response.Id,
            },
            referenceId,
            increased,
            SendSMS
          );
          getInvoiceAsync();
        } else {
          const res = await putItemRequestworkflow(
            {
              ...data,
              JobId: jobId,
              JobNo: response.JobNo ? response.JobNo : JobNo,
              TAS_UID: taskId,
              Id: response?.Id,
            },
            referenceId
          );
        }
      }
    } catch (error: any) {
      if (error.response.data.MessageType == MessageType.confirm) {
        setDateLoading(false);
        Toast(error.response.data.Message, MessageType.confirm, () => {
          setResponse({
            ...error.response.data.Data,
            ItemRequestDate: salesInvoiceDate,
          });
          setItemRequestDetail(

              error.response.data.Data?.ItemRequestDetailDTOList.map(item=>{
                          
                          return {...item,ExpireDate:item?.ExpireDate?ConvertiSolarDateToGregorianDate(item?.ExpireDate).toISOString():null}})
            

          );
          let newItemCount = 0;
          error.response.data.Data?.ItemRequestDetailDTOList.map((item) => {
            newItemCount += item.Qty1;
          });
          setTotalRows({
            ItemCount: newItemCount,
          });

          setResponseList(null);
          setDateLoading(true);
        });
      }
    }
    document.body.classList.remove("loading-indicator-" + lang);
  };


  //   let SubTotalPrice: any = 0;
  //   let newsalesInvoiceDetail = JSON.parse(
  //     JSON.stringify(salesInvoiceDetail)
  //   ).map((e: any) => {
  //     SubTotalPrice = +e.TotalPrice + SubTotalPrice;

  //     return e;
  //   });

  //   let data: any = {
  //     RecipientPersonDescription: person?.Name??null,
  //     RecipientPersonId: person?.Id??null,
  //     CurrencyId: newPriceList?.CurrencyId,
  //     ItemRequestNo: invoiceRef.current?.salesInvoiceNo?.value ?invoiceRef.current?.salesInvoiceNo?.value:nextInvoiceNumber,
  //     ItemRequestDate: salesInvoiceDate,
  //     DocsClassificationId:invoiceRef.current?.docsClassificationId?.value!==GUID_EMPTY?invoiceRef.current?.docsClassificationId?.value:null,
  //     PriceListId: newPriceList ?newPriceList.Id  :invoiceRef.current?.PriceList?.value,
  //     PaymentMethodId: invoiceRef.current?.PaymentMethodId?.value,
  //     CustomerId: customerInfo?.Id,
  //     CustomerName: customer?.Name,
  //     CustomerPhone:customer.SundryCustomer?invoiceRef.current?.CustomerPhone?.value: customer?.CustomerPhone?.Name.split(":")[1]?customer?.CustomerPhone?.Name.split(":")[1] :customer?.CustomerPhone?.Name??null,
  //     CustomerMobilePhone:customer.SundryCustomer?invoiceRef.current?.CustomerMobilePhone?.value: customer?.CustomerMobilePhone?.Name.split(":")[1]?customer?.CustomerMobilePhone?.Name.split(":")[1] :customer?.CustomerMobilePhone?.Name??null,
  //     CustomerAddress: invoiceRef.current.Address?.value??null,
  //     CustomerEconNo: invoiceRef.current?.CustomerEconNo?.value,
  //     CustomerNationalCode: invoiceRef.current?.CustomerNationalCode?.value,
  //     SalesManagerPositionId: listPosition?.SalesManagerPosition?.Id,
  //     SalesManagerPositionDescription: listPosition?.SalesManagerPosition?.Name,
  //     SalesManagerPositionDescriptionEN:
  //       invoiceRef.current?.SalesManagerPositionDescriptionEN?.value,
  //     VisitorPositionId: listPosition?.VisitorPosition?.Id,
  //     VisitorPositionDescription: listPosition?.VisitorPosition?.Name,
  //     VisitorPositionDescriptionEN:
  //       invoiceRef.current?.VisitorPositionDescriptionEN?.value,
  //     DistributorPositionId: listPosition?.DistributorPosition?.Id,
  //     DistributorPositionDescription: listPosition?.DistributorPosition?.Name,
  //     DistributorPositionDescriptionEN:
  //       invoiceRef.current?.DistributorPositionDescriptionEN?.value,
  //     CottageDate: cottageDate,
  //     DeliveryAddress: invoiceRef.current?.DeliveryAddress?.value,
  //     CottageNo: invoiceRef.current?.CottageNo?.value,
  //     PaymentRemark: invoiceRef.current?.PaymentRemark?.value,
  //     IsCurrancyInvoice: invoiceRef.current?.IsCurrancyInvoice?.checked,
  //     //CurrencyPrepayment: +invoiceRef.current?.CurrencyPrepayment?.value,
  //     Description: invoiceRef.current?.Description?.value,
  //     SourceId: response?.SourceId,
  //     SourceData: haveSource?haveSource:response?.SourceData,
  //     IsCurrency: !currencyInfo?.IsDefault,
  //     CurrencyRate: currencyInfo?.CurrencyRate,
  //     Addition: +invoiceRef.current?.Addition?.value.replaceAll(",", ""),
  //     Deduction: +invoiceRef.current?.Deduction?.value.replaceAll(",", ""),
  //     TotalDiscount: +totalRows?.TotalDiscount,
  //     TotalPrice: +payment.totalprice,
  //     TotalTax: (docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& invoiceConstraint.HasTax)) ?    +totalRows?.TotalTax: 0,
  //     GrandTotalPrice:
  //       +totalRows?.SubTotalPrice -
  //       +totalRows?.TotalDiscount +
  //       +totalRows?.TotalTax +
  //       +invoiceRef.current?.Addition?.value.replaceAll(",", "") -
  //       +invoiceRef.current?.Deduction?.value.replaceAll(",", ""),
  //     DebitPayment: +invoiceRef.current?.DebitPayment?.value.replaceAll(",", ""),
  //     NonDebitPayment: +invoiceRef.current?.NonDebitPayment?.value.replaceAll(",", ""),
  //     CreditPayment: +invoiceRef.current?.CreditPayment?.value.replaceAll(",", ""),
  //     Prepayment: +invoiceRef.current?.Prepayment?.value.replaceAll(",", ""),

  //     ItemRequestDetailDTOList: newsalesInvoiceDetail,
  //     JobId: jobId,
  //     JobNo: response.JobNo ? response.JobNo : JobNo,
  //     TAS_UID: taskId,
  //     Id: response.Id,
  //   };
  //   setDateLoading(false)

  //   try {

  //     if ((mode !== "view"&& priceList.Id != newPriceList?.Id)||newPriceList==null) {
  //       const res = await CalculateItemRequest(data);
  //       setResponse(res.Data);

  //       setItemRequestDetail(res.Data?.ItemRequestDetailDTOList	);
  //       let newItemCount = 0;
  //       res.Data?.ItemRequestDetailDTOList.map((item) => {
  //         newItemCount += item.Qty1;
  //       });
  //       setTotalRows({
  //         ItemCount: newItemCount,

  //       });

  //       setResponseList(null)

  //     }
  //     setPriceList(newPriceList);
  //   } catch (error:any) {
  //     if(error.response?.data?.Data[0]&&error.response?.data?.Data?.[0]?.Message){
  //       let obj = {}
  //       error.response.data.Data.map(item=>{
  //         obj[item.Data] = item
  //       })
  //       setResponseList(obj)
  //     }
  //     setPriceList(priceList);
  //   }
  //   if(Classification) setDocsClassification(Classification)
  //     setDateLoading(true)

  // };

  async function getInvoiceConstraintAsync(withLoading = false) {
    if (withLoading) setLoading(false);
    try {
      const res = await getInvoiceConstraint();
      setInvoiceConstraint(res.Data);
      setNextInvoiceNumber(res.Data?.DocNo);
      setRequiredFields(res.Data.RequiredFields?JSON.parse(res.Data.RequiredFields):null);
      if (withLoading) setLoading(true);
      return res.Data;
    } catch (error) {}
    if (withLoading) setLoading(true);
  }

  async function getInvoiceAsync() {
    setLoading(false);
    //  const constraint= await getInvoiceConstraintAsync();
    let constraint = {} as any;
    if (mode != "view") {
      constraint = await getInvoiceConstraintAsync();
    }
    try {
      if (jobId) {
        let res: any;
        if ((useGenerate && (sourceDataParam && mode != "view")) ) {
          res = await getItemRequestOrGenerate(
            sourceDataParam,
            sourceId,
            referenceId,
            jobId
          );
        } else {
          //res = await getItemRequestById(jobId);
          res = await getItemRequestByReferenceId(referenceId);
        }
        if (res.Data.Id != GUID_EMPTY)
          setNextInvoiceNumber(res.Data.ItemRequestNo);
        // if(res.Data.Id && res.Data.Id!=GUID_EMPTY){
        //   if(invoiceRef1.current!=null){
        //     buttonPrintObjCallBack&& buttonPrintObjCallBack({
        //       Id: res.Data.Id ,
        //       reportDomain:"OfficeAutomation",
        //       objectTag:"ItemRequestForm",
        //       apiFunction:getDataForPrint
        //     })
        //   }
        // }else{
        //   buttonPrintObjCallBack&& buttonPrintObjCallBack(null)
        // }
        setResponse(res.Data);
        let count = 0;
        res.Data.ItemRequestDetailDTOList.map((item) => {
          count += +item?.Qty1;
        });
        setHaveSource(res.Data.SourceData);
        setItemRequestDetail(res.Data.ItemRequestDetailDTOList);

        setTotalRows({
          ItemCount: count,
        });

        if (mode == "view")
          setInvoiceConstraint({ IsFiscal: res.Data.IsFiscal });
      } else {
        const res = await getItemRequestById(rowObject.Id);

        setHaveSource(res.Data.SourceData);
        setNextInvoiceNumber(res.Data.ItemRequestNo);

        // if(res.Data.Id && res.Data.Id!=GUID_EMPTY){
        //   if(invoiceRef1.current!=null){
        //   buttonPrintObjCallBack&& buttonPrintObjCallBack({
        //     Id: res.Data.Id ,
        //     reportDomain:"OfficeAutomation",
        //     objectTag:"ItemRequestForm",
        //     apiFunction:getDataForPrint
        //   })}
        // }else{
        //   buttonPrintObjCallBack&& buttonPrintObjCallBack(null)
        // }
        setResponse(res.Data);
        let count = 0;
        res.Data.ItemRequestDetailDTOList.map((item) => {
          count += +item?.Qty1;
        });
        setItemRequestDetail(res.Data.ItemRequestDetailDTOList);
        setTotalRows({
          ItemCount: count,
        });
      }
    } catch (error) {}
    setLoading(true);
  }

  // async function optionalDiscountHandlerAsync() {
  //   let data = {
  //     CurrencyRoundingPlace: currencyInfo?.CurrencyRoundingPlace,
  //     OptionalDiscount: +optionalDiscount,
  //     Addition: +payment.Addition,
  //     Deduction: +payment.Deduction,
  //     DetailDTOList: salesInvoiceDetail,
  //   };
  //   try {
  //     const res = await optionalDiscountHandler(data);
  //     setTotalRows({
  //       ItemCount: res.Data.ItemCount,
  //       TotalTax:(docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& invoiceConstraint.HasTax))? res.Data.TotalTax:0,
  //       TotalDiscount: res.Data.TotalDiscount,
  //       SubTotalPrice: res.Data.SubTotalPrice,
  //     });

  //     setItemRequestDetailHandler(res.Data.ItemRequestDetailDTOList);
  //   } catch (error) {}
  // }

  const handleOpenDetailForm = () => {
    setShowForm(true);
    setDetailMode("create");
  };

  const handlesetPriceListDetail = (newObj) => {
   if(detailMode == "create" || (detailMode == "edit" && newObj.ItemCode!=selectedObj.ItemCode)){
     setIncreased(true)
    }
    if (invoiceConstraint.AllowDuplicateItems || detailMode == "edit") {
      setTotalRows({
        ItemCount:
          detailMode == "create"
            ? RoundOutputOperation(totalRows.ItemCount + +newObj.Qty1)
            : RoundOutputOperation(
                totalRows.ItemCount + (+newObj.Qty1 - +selectedObj.Qty1)
              ),
      });

      if (detailMode == "create") {
        setItemRequestDetailHandler([...salesInvoiceDetail, newObj]);
      } else {
        let newItemes = salesInvoiceDetail?.map((item: any) => {
          if (item.Id == newObj.Id) {
            return newObj;
          } else return item;
        });
        setItemRequestDetailHandler(newItemes);
      }
      setDataChange(true);
      return true;
    } else {
      let Dupli = salesInvoiceDetail?.find(
        (e: any) => e.ItemId == newObj.ItemId
      );
      if (!Dupli || salesInvoiceDetail.length == 0) {
        setTotalRows({
          ItemCount:
            detailMode == "create"
              ? RoundOutputOperation(totalRows.ItemCount + newObj.Qty1)
              : RoundOutputOperation(
                  totalRows.ItemCount + (+newObj.Qty1 - +selectedObj.Qty1)
                ),
        });
        if (detailMode == "create") {
          setItemRequestDetailHandler([...salesInvoiceDetail, newObj]);
        } else {
          let newItemes = salesInvoiceDetail?.map((item: any) => {
            if (item.Id == newObj.Id) {
              return newObj;
            } else return item;
          });
          setItemRequestDetailHandler(newItemes);
        }
        setDataChange(true);
        // Toast("msg_saveddatasuccessfully", "success");
        Toast("msg_saveddatasuccessfully", MessageType.success);

        return true;
      } else {
        // Toast("msg_duplicateitems", "error");
        Toast("msg_duplicateitems", MessageType.error);

        return false;
      }
    }
  };
  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
  };

  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide && onHide();
      // });
      Toast(trans("modalclosemessage"), MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide && onHide();
      });
    } else {
      onHide && onHide();
    }
  }

  //   const getDataForPrintAsync =async (id) => {
  //     if(response?.Id){
  //         if(id.includes("Design")){
  //             const res = await getDataForPrint(response?.Id)
  //             GetReportWithJsonData( id.replace("Design" , ""), res.Data ,2)
  //         }else if(id.includes("Default")){
  //             const res = await getDataForPrint(response?.Id)
  //             GetReportWithJsonData( id.replace("Default" , ""), res.Data ,2)
  //         }else{
  //             const res = await getDataForPrint(response?.Id)
  // /*               const dataStr = JSON.stringify(res.Data);
  //             const blob = new Blob([dataStr], { type: 'application/json' });
  //             const url = URL.createObjectURL(blob); */
  //            GetReportWithJsonData( id, res.Data ,1 )
  //         }
  //     }
  //     try {
  //     } catch (error) {

  //     }
  // };

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  const handleDeleteRow = async (id: string = selectedObj.Id) => {
    let newPriceListDetail: any = [...salesInvoiceDetail];
    let obj = newPriceListDetail.filter((e) => e.Id == id)[0];

    setTotalRows({
      ItemCount: RoundOutputOperation(totalRows.ItemCount - +obj.Qty1),
    });
    setItemRequestDetailHandler(newPriceListDetail.filter((e) => e.Id != id));
  };

  const handleSourceData = (obj, type) => {
    setResponse(obj);
    setHaveSource(type);
    setPriceList({ ...priceList, Id: obj.PriceListId });
    setItemRequestDetailHandler(obj.ItemRequestDetailDTOList);
    setTotalRows({
      ItemCount: obj?.ItemCount,
    });
    setCustomer((prev) => {
      return { ...prev, Id: obj?.CustomerId, Name: obj?.CustomerName };
    });
  };
  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  useEffect(() => {
    if (mode != "create") {
      getInvoiceAsync();
    } else {
      getInvoiceConstraintAsync(true);
    }
  }, []);
  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  const getItemRequestNoAsync = async () => {
    try {
      const res = await getItemRequestNo(
        docsClassification?.Id != GUID_EMPTY ? docsClassification?.Id : null
      );
      setNextInvoiceNumber(res.Data);
    } catch (error: any) {}
  };

  useEffect(() => {
    if (
      mode != "view" &&
      jobId
      // docsClassification?.Id != GUID_EMPTY &&
      // !invoiceConstraint.IsClassificationIgnored
    ) {
      getItemRequestNoAsync();
    } else {
      setNextInvoiceNumber(response?.ItemRequestNo + "");
    }
  }, []);

  return (
    <div ref={invoiceRef1} className=" ">
      {showForm ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowForm(false);
          }}
          show={showForm}
          title={"ItemRequestDetail"}
        >
          <ItemRequestDetailForm
            setLastWarehouse={setLastWarehouse}
            lastWarehouse={lastWarehouse}
            mode={detailMode}
            onHide={() => {
              setShowForm(false);
            }}
            jobId={jobId}
            docsClassification={docsClassification}
            priceList={priceList}
            invoiceConstraint={invoiceConstraint}
            selectedObj={selectedObj}
            ItemRequestDetailCallBack={(e) => handlesetPriceListDetail(e)}
            personId={customerInfo?.CustomerPersonId}
            currency={currencyInfo}
            ItemRequestId={response?.Id}
          />
        </ModalForm>
      ) : (
        <></>
      )}

      {loading ? (
        <form onSubmit={handleItemRequestDetailFormSubmit} ref={invoiceRef}>
          {/* <div className="col-12 d-flex justify-content-end" style={{position:'absolute',top:'30px',zIndex:'10'}}>
        {  (response?.Id!==GUID_EMPTY && response?.Id) &&  <ButtonPrintIcon reportDomain={"OfficeAutomation"}  objectTag={"ItemRequestForm"} Callback={(e) => {getDataForPrintAsync(e)}} />}
            </div> */}
          <FormWithTitle
            title={trans("ItemRequest")}
            defualtClose={true}
            showFristRow={true}
            closeOption={true}
            dynamicTitle={{
              CustomerName: customer?.Name,
              ItemRequestNo: nextInvoiceNumber=='undefined'?'':nextInvoiceNumber,
            }}
          >
            <div className="card-body"  style={{paddingTop:'1px'}}>
              <div className="row">
                <div className="col-lg-1 col-11">
                  <ItemRequestSourceId
                    SourceObjCallBack={(e, type) => {
                      handleSourceData(e, type);
                    }}
                    value={haveSource ? haveSource : "undefined"}
                    resetForm={resetForm}
                    dataChange={dataChange}
                    mode={jobId?'view':mode}

                  />
                </div>
                {/* 
                {invoiceConstraint?.IsDocClassified && (
                  <div className="col-lg-2 col-11 me-lg-3 mt-3 mt-lg-0">
                    <DocsClassification
                      label="Classification"
                      name="docsClassificationId"
                      baseUrl={INVENTORYANDSALES_URL}
                      IsDocClassified={invoiceConstraint?.IsDocClassified}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Sales
                          .BaseDefinitionAndSetting.SalesDocsClassification
                          .dictionary
                      }
                      resetForm={resetForm}
                      value={docsClassification?docsClassification?.Id: response?.DocsClassificationId}
                      mode={ mode}
                      onChange={(e,obj) => {
                        if((docsClassification?.CalculateTax!=obj?.CalculateTax)&&docsClassification!=null){sendDataForCalcAsync(null , obj) }else    setDocsClassification(obj);
                      }}
                      
                    />
                  </div>
                )} */}

                <div className="col-lg-1 col-11">
                  <Textbox
                    textboxType="text"
                    textboxName="ItemRequestNo"
                    labelText="number"
                    defaultValue={nextInvoiceNumber + ""}
                    resetForm={resetForm}
                    readonly={
                      !invoiceConstraint?.IsDocNoEditable || mode !== "create"
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      setNextInvoiceNumber(e.target.value);
                    }}
                    mode={jobId?'view':mode}

                  />
                </div>

                {dateLoading && (
                  <div className="col-lg-2 col-11">
                    <Datepicker
                                           mode={jobId?'view':mode}

                      lable="Date"
                      required={true}
                      setIsoTime={(isoTime: string) => {
                        setItemRequestDate(isoTime);
                      }}
                      val={
                        response?.ItemRequestDate
                          ? response?.ItemRequestDate
                          : invoiceConstraint?.IsNewDocCurrentDate
                          ? todayDate
                          : null
                      } //resetForm ? new Date().toISOString() :
                      errorFlag={false}
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                    />
                  </div>
                )}

                {/* {mode=='create' && <div className="col-lg-2 col-11 d-flex align-items-center mb-1 mb-lg-0">
                           <CheckableButton
                                Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                defaultChecked={SendSMS}
                                defaultValue={SendSMS}
                                readOnly={mode==='view'}
                                checked={SendSMS}
                                onchange={setSendSMS}
                                labelText={"NotifyBySMS"}
                                inputName={"NotifyBySMS"}
                                type="checkbox"
                                mode={mode}
                                />
                            </div>} */}

                <div className="col-lg-3 col-11">
                  <Person
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    value={
                      response?.RecipientPersonId
                        ? response?.RecipientPersonId
                        : customerInfo?.RecipientPersonId
                    }
                    resetForm={resetForm}
                    mode={jobId?'view':mode}

                    WithSearch={false}
                    setPerson={setPerson}
                    returnObj={true}
                    name={"RecipientPersonDescription"}
                    label="RecipientPerson"
                    required={requiredFields?.RecipientPersonId}
                    valueString={response?.RecipientPersonDescription}
                  />
                </div>

                {/*                         <div className="col-lg-2">
                            <Textbox
                             Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                             textboxName="Prepayment"
                             textboxType="number"
                             labelText="Prepayment"
                             defaultValue={response?.Prepayment}
                             resetForm={resetForm}
                             mode={mode == 'view'?"view": mode}
                             required={true}
                            />
                        </div> */}
                {/*                         <div className="col-lg-2">
                            <Textbox
                            Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                            textboxName="VisitorPositionDescriptionEN"
                            textboxType="text"
                            labelText="VisitorPositionDescriptionEN"
                            defaultValue={response?.VisitorPositionDescriptionEN}
                            resetForm={resetForm}
                            mode={mode == 'view'?"view": mode}
                            />
                            </div> */}
                {/*  <div className="col-lg-2">
                                 <Textbox
                                  Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                  textboxName="DistributorPositionDescriptionEN"
                                  textboxType="text"
                                  labelText="DistributorPositionDescriptionEN"
                                  defaultValue={response?.DistributorPositionDescriptionEN}
                                  resetForm={resetForm}
                                  mode={mode == 'view'?"view": mode}
                                 />
                                </div> */}
                {/*                         <div className="col-lg-2">
                            <Textbox
                             Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                             textboxName="SalesManagerPositionDescriptionEN"
                             textboxType="text"
                             labelText="SalesManagerPositionDescriptionEN"
                             defaultValue={response?.SalesManagerPositionDescriptionEN}
                             resetForm={resetForm}
                             mode={mode == 'view'?"view": mode}
                            />
                           </div> */}

                <div className="col-lg-2 col-11 mr-2">
                  <Position
                    name="VisitorPositionId"
                    label="VisitorPosition"
                    resetForm={resetForm}
                    value={
                      customerInfo?.VisitorPositionId
                        ? customerInfo?.VisitorPositionId
                        : response?.VisitorPositionId
                    }
                    mode={jobId?'view':mode}

                    returnObj={true}
                    onChange={(e) => {
                      setListPosition({ ...listPosition, VisitorPosition: e });
                    }}
                    required={requiredFields?.VisitorPositionId}
                  />
                </div>
                {/* <div className="col-lg-2 col-11">
                  <Position
                    name="DistributorPositionId"
                    label="DistributorPosition"
                    resetForm={resetForm}
                    value={
                      customerInfo?.DistributorPositionId
                        ? customerInfo?.DistributorPositionId
                        : response?.DistributorPositionId
                    }
                    mode={'view'}
                    returnObj={true}
                    onChange={(e) => {
                      setListPosition({
                        ...listPosition,
                        DistributorPosition: e,
                      });
                    }}
                    required={requiredFields?.DistributorPositionId}
                  />
                </div> */}

                <div className="col-lg-2 col-11">
                  <Position
                    name="SalesManagerPositionId"
                    label="salesmanagerpositiondescription"
                    resetForm={resetForm}
                    value={
                      customerInfo?.ItemRequestStatusId
                        ? customerInfo?.ItemRequestStatusId
                        : response?.SalesManagerPositionId
                    }
                    mode={jobId?'view':mode}

                    returnObj={true}
                    onChange={(e) => {
                      setListPosition({
                        ...listPosition,
                        SalesManagerPosition: e,
                      });
                    }}
                    required={requiredFields?.SalesManagerPositionId}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="DeliveryAddress"
                    textboxType="text"
                    labelText="DeliveryAddress"
                    defaultValue={
                      response?.DeliveryAddress ? response.DeliveryAddress : ""
                    }
                    resetForm={resetForm}
                    mode={jobId?'view':mode}

                    required={requiredFields?.DeliveryAddress}
                  />
                </div>

                <div className="col-lg-5 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="Description"
                    textboxType="textarea"
                    labelText="Description"
                    minHeight={1}
                    defaultValue={response?.Description}
                    resetForm={resetForm}
                    mode={jobId?'view':mode}

                    maxLength={900}
                    letterCounter={true}
                    required={requiredFields?.Description}
                  />
                </div>
              </div>
            </div>
          </FormWithTitle>
          <div className="mt-3">
            <FormWithTitle title={trans("Details")}>
              <div>
                <div className="row align-items-center justify-content-between">
                  {mode !== "view" && !jobId && (
                    <div className="col-2">
                      <div
                        onClick={handleOpenDetailForm}
                        className="col-2 mb-1 btn btn-success btn-sm d-flex align-items-center justify-content-between "
                        style={{
                          width: "70px",
                          maxHeight: "30px",
                          marginRight: "20px",
                          minWidth: "70px",
                        }}
                      >
                        <span className=" font-size-md ms-2 ">
                          {trans("add")}
                        </span>
                        <FontAwesomeIcon
                          size="xs"
                          icon={["fas", "plus"]}
                          className="color_text_light d-flex Requests__chatbox-reply-btn mx-1 p-1"
                          color="white"
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-10 row" style={{ justifyContent: "end" }}>
                    <div className="d-flex justify-content-end align-items-center">
                      {mode != "view" && (
                        <div className="d-flex align-items-center justify-content-center mb-1 flex-wrap"></div>
                      )}
                      <div
                        className={`${
                          mode != "view" ? "col-7" : "col-12"
                        }  row justify-content-end mb-1`}
                      >
                        <Headerbar
                          withPading={false}
                          headerContents={totalRows}
                          hasBorder={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {dataGridLoading ? (
                  <>
                    {(
                      mode == "view"
                        ? salesInvoiceDetail?.length > 0
                        : invoiceConstraint?.Detail
                    ) ? (
                      <>
                        <DataGrid
                          useChangingNumberPlacement={true}
                          useLanguage={true}
                          responseList={responseList}
                          convertDateColNames={["ExpireDate"]}
                          DoubleClick={(e) => {
                            setSelectedObj(e);
                            setShowForm(true);
                            setDetailMode("view");
                          }}
                          parentName={"ItemRequestDetailList"}
                          startIndex={18}
                          theadData={
                            mode !== "view"
                              ? Object.keys(invoiceConstraint?.Detail)
                              : Object.keys(salesInvoiceDetail?.[0])
                          }
                          tbodyData={
                            salesInvoiceDetail?.length > 0
                              ? salesInvoiceDetail
                              : [invoiceConstraint?.Detail]
                          }
                          totalRecords={
                            salesInvoiceDetail?.length > 0 ? undefined : 0
                          }
                          scrollHeight={"67vh"}
                          minCellWidth={80}
                          selectedRowObjectCallback={selectedObjCallback}
                          handleEdit={
                            !jobId && mode != "view"
                              ? (e) => {
                                  setSelectedObj(e);
                                  setDetailMode("edit");
                                  setShowForm(true);
                                }
                              : undefined
                          }
                          rowSelected={selectedObj}
                          // handleDelete={
                          //   mode != "view"
                          //     ? (e) => {
                          //         // Toast(
                          //         //   trans("msg_deleteconfirm"),
                          //         //   "warning",
                          //         //   "alert",
                          //         //   () => handleDeleteRow(e)
                          //         // );
                          //         Toast(
                          //           trans("msg_deleteconfirm"),
                          //           MessageType.confirmDelete,
                          //           () => handleDeleteRow(e)
                          //         );
                          //       }
                          //     : undefined
                          // }
                          handleView={(e) => {
                            setSelectedObj(e);
                            setDetailMode("view");
                            setShowForm(true);
                          }}
                        />
                      </>
                    ) : (
                      <Message message={"NoDataForPreview"} type={"info"} />
                    )}
                  </>
                ) : (
                  <Loading />
                )}
              </div>
            </FormWithTitle>
          </div>

          <div className="card">
            <div className="card-body ">
              <div className="row">
                <div className=" d-flex justify-content-end">
                  {mode != "view" && (
                    <div className="col-lg-12 mt-4  btns_form">
                      <Button
                        outline={false}
                        disabled={
                          responseList ||
                          invoiceRef.current?.salesInvoiceNo?.value == ""
                        }
                        value="save"
                        btnType="submit"
                      />
                      {!jobId && (
                        <Button
                          btnType="cancel"
                          value="Cancel"
                          onClick={() => {
                            cancel();
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      ) : (
        <Loading />
      )}
    </div>
  );
};
